export interface User {
  id: number | string;
  username: string;
  role: string;
  accessToken: string;
  refreshToken: string;
}

export interface RootState {
  version: string;
  user: User | null;
  exerciseTypes: any;
}

export enum RootMutations {
  SET_USER = 'SET_USER',
  REMOVE_USER = 'REMOVE_USER'
}
